import axios, { AxiosRequestConfig } from "axios";
import { HTTPMethods } from "../types/http";

export const getDataFromRequest = async (
    endpoint: string,
    httpMethod: HTTPMethods = HTTPMethods.GET,
    token: string | null = null,
    data: any = null,
    config: AxiosRequestConfig = {
        headers: {
            "Content-Type": "application/json",
        },
    },
    failSilently: boolean = false
): Promise<any> => {
    let configUsed = config;

    if (token) {
        configUsed = {
            ...configUsed,
            headers: {
                Authorization: `Bearer ${token}`,
                ...configUsed.headers,
            },
        };
    }

    try {
        switch (httpMethod) {
            case HTTPMethods.GET:
                return (await axios.get(endpoint, configUsed)).data;
            case HTTPMethods.POST:
                return (await axios.post(endpoint, data, configUsed)).data;
            case HTTPMethods.PATCH:
                return (await axios.patch(endpoint, data, configUsed)).data;
            case HTTPMethods.DELETE:
                return (await axios.delete(endpoint, configUsed)).data;
        }
    } catch (err) {
        if (failSilently) return;

        // @ts-ignore
        alert(err?.response?.data?.message || "Error"); // TODO: Add better error handling
    }
};
